module.exports = __webpack_public_path__ + "static/media/hiw-infinity-min.aff17981.png";